import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import { closeCountrySelectorOnEscape } from '../../../utilities/behavior-helpers/index.js';
import { ButtonTypes, ButtonStyleTypes } from '../enums.js';
import css_248z from './icon-button.scss.js';

class IconButton extends s {
    constructor() {
        super(...arguments);
        this.type = ButtonTypes.BUTTON;
        this.styleType = ButtonStyleTypes.LIGHT;
        this.disabled = false;
        this.basic = false;
        this.darkbgoutline = false;
        this.fixedSize = false;
    }
    keyPressHandler() {
        this.addEventListener('keydown', (event) => {
            const shift = event.shiftKey;
            const { activeElement } = document;
            if (this.ariaLabel.toLowerCase() === 'close' &&
                event.key === 'Tab' &&
                shift &&
                ((activeElement === null || activeElement === void 0 ? void 0 : activeElement.shadowRoot.querySelector('.global-nav')) ||
                    activeElement === this)) {
                event.preventDefault();
            }
            if (event.key === 'Escape') {
                const isInGlobalNav = this.closest('.global-nav');
                if (isInGlobalNav) {
                    const globalNav = document.querySelector('global-nav');
                    closeCountrySelectorOnEscape(globalNav, true);
                }
            }
        });
    }
    firstUpdated() {
        this.keyPressHandler();
    }
    render() {
        return x `<button tabindex="${this.customTabIndex || ''}" class="icon-button style-${this.styleType} ${this.disabled ? 'disabled' : ''} ${this.basic ? 'basic' : ''} ${this.darkbgoutline ? 'darkbgoutline' : ''} ${this.fixedSize ? 'fixed-size' : ''}" type="${l(this.type)}" ?disabled="${this.disabled}" @click="${this.onClick}" aria-label="${this.ariaLabel}"><slot name="icon"></slot></button>`;
    }
}
IconButton.styles = css_248z;
__decorate([
    n({ type: String })
], IconButton.prototype, "type", void 0);
__decorate([
    n({ type: Number })
], IconButton.prototype, "customTabIndex", void 0);
__decorate([
    n({ type: String })
], IconButton.prototype, "styleType", void 0);
__decorate([
    n({ type: Boolean })
], IconButton.prototype, "disabled", void 0);
__decorate([
    n({ type: Boolean })
], IconButton.prototype, "basic", void 0);
__decorate([
    n({ type: Boolean })
], IconButton.prototype, "darkbgoutline", void 0);
__decorate([
    n({ type: Boolean })
], IconButton.prototype, "fixedSize", void 0);
__decorate([
    n({ type: String })
], IconButton.prototype, "ariaLabel", void 0);
__decorate([
    n()
], IconButton.prototype, "onClick", void 0);
customElements.define('icon-button', IconButton);

export { IconButton };
